/* global axios */
import ApiClient from './ApiClient';

class SalesTeamsAPI extends ApiClient {
  constructor() {
    super('sales_teams', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(teamId, managerId) {
    return axios.patch(`${this.url}/${teamId}`, { manager_id: managerId });
  }
}

export default new SalesTeamsAPI();
